import _toArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function t(t) {
  var n = "";
  return t.absolute && ("file" === t.protocol ? (t.drive && (n += t.drive), n += "/") : (n += t.protocol + "://", t.origin && (n += t.origin + "/"))), "" === (n += t.path.join("/")) && (n = "."), n;
}

function n(t, r, e, o) {
  this.message = t, this.expected = r, this.found = e, this.location = o, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, n);
}

!function (t, n) {
  function r() {
    this.constructor = t;
  }

  r.prototype = n.prototype, t.prototype = new r();
}(n, Error), n.buildMessage = function (t, n) {
  var r = {
    literal: function literal(t) {
      return '"' + o(t.text) + '"';
    },
    class: function _class(t) {
      var n,
          r = "";

      for (n = 0; n < t.parts.length; n++) {
        r += t.parts[n] instanceof Array ? u(t.parts[n][0]) + "-" + u(t.parts[n][1]) : u(t.parts[n]);
      }

      return "[" + (t.inverted ? "^" : "") + r + "]";
    },
    any: function any(t) {
      return "any character";
    },
    end: function end(t) {
      return "end of input";
    },
    other: function other(t) {
      return t.description;
    }
  };

  function e(t) {
    return t.charCodeAt(0).toString(16).toUpperCase();
  }

  function o(t) {
    return t.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (t) {
      return "\\x0" + e(t);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (t) {
      return "\\x" + e(t);
    });
  }

  function u(t) {
    return t.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (t) {
      return "\\x0" + e(t);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (t) {
      return "\\x" + e(t);
    });
  }

  return "Expected " + function (t) {
    var n,
        e,
        o,
        u = new Array(t.length);

    for (n = 0; n < t.length; n++) {
      u[n] = (o = t[n], r[o.type](o));
    }

    if (u.sort(), u.length > 0) {
      for (n = 1, e = 1; n < u.length; n++) {
        u[n - 1] !== u[n] && (u[e] = u[n], e++);
      }

      u.length = e;
    }

    switch (u.length) {
      case 1:
        return u[0];

      case 2:
        return u[0] + " or " + u[1];

      default:
        return u.slice(0, -1).join(", ") + ", or " + u[u.length - 1];
    }
  }(t) + " but " + function (t) {
    return t ? '"' + o(t) + '"' : "end of input";
  }(n) + " found.";
};

var r = function r(t, _r) {
  _r = void 0 !== _r ? _r : {};

  var e,
      o,
      u,
      i,
      c = {},
      a = {
    Path: nt
  },
      l = nt,
      s = function s(t, n, r, e) {
    return _objectSpread({
      protocol: t,
      origin: n,
      absolute: !0
    }, r, e);
  },
      f = function f(t, n, r) {
    return _objectSpread({
      protocol: t,
      origin: n,
      absolute: !0
    }, r, {
      path: []
    });
  },
      p = "http://",
      h = W("http://", !0),
      g = function g(t) {
    return "http";
  },
      v = "https://",
      d = W("https://", !0),
      b = function b(t) {
    return "https";
  },
      x = "",
      m = function m() {
    return null;
  },
      C = function C(t, n, r) {
    return _objectSpread({
      protocol: t,
      origin: null,
      absolute: !0
    }, n, r);
  },
      w = "file://",
      A = W("file://", !0),
      y = "file:",
      j = W("file:", !0),
      F = function F(t) {
    return "file";
  },
      S = function S(t, n) {
    return _objectSpread({
      protocol: "file",
      origin: null,
      absolute: !0
    }, t, n);
  },
      E = /^[A-Za-z]/,
      L = X([["A", "Z"], ["a", "z"]], !1, !1),
      R = ":",
      $ = W(":", !1),
      M = function M(t) {
    return {
      drive: t.toLowerCase() + ":"
    };
  },
      k = function k() {
    return {
      drive: null
    };
  },
      z = function z() {
    return {
      drive: null
    };
  },
      B = function B(t) {
    return _objectSpread({
      protocol: null,
      origin: null,
      absolute: !1,
      drive: null
    }, t);
  },
      O = function O(t) {
    return {
      path: t
    };
  },
      P = function P(t, n) {
    return [t].concat(_toConsumableArray(n));
  },
      T = function T(t) {
    return [t];
  },
      Z = ".",
      I = W(".", !1),
      U = "/",
      q = W("/", !1),
      D = "\\",
      G = W("\\", !1),
      H = /^[^\/\\]/,
      J = X(["/", "\\"], !0, !1),
      K = 0,
      N = [{
    line: 1,
    column: 1
  }],
      Q = 0,
      V = [];

  if ("startRule" in _r) {
    if (!(_r.startRule in a)) throw new Error("Can't start parsing from rule \"" + _r.startRule + '".');
    l = a[_r.startRule];
  }

  function W(t, n) {
    return {
      type: "literal",
      text: t,
      ignoreCase: n
    };
  }

  function X(t, n, r) {
    return {
      type: "class",
      parts: t,
      inverted: n,
      ignoreCase: r
    };
  }

  function Y(n) {
    var r,
        e = N[n];
    if (e) return e;

    for (r = n - 1; !N[r];) {
      r--;
    }

    for (e = {
      line: (e = N[r]).line,
      column: e.column
    }; r < n;) {
      10 === t.charCodeAt(r) ? (e.line++, e.column = 1) : e.column++, r++;
    }

    return N[n] = e, e;
  }

  function _(t, n) {
    var r = Y(t),
        e = Y(n);
    return {
      start: {
        offset: t,
        line: r.line,
        column: r.column
      },
      end: {
        offset: n,
        line: e.line,
        column: e.column
      }
    };
  }

  function tt(t) {
    K < Q || (K > Q && (Q = K, V = []), V.push(t));
  }

  function nt() {
    var n;
    return (n = function () {
      var t, n, r, e, o;
      return t = K, (n = rt()) !== c && (r = et()) !== c && (e = ut()) !== c && (o = it()) !== c ? (n = s(n, r, e, o), t = n) : (K = t, t = c), t === c && (t = K, (n = rt()) !== c && (r = et()) !== c && (e = function () {
        var t;
        return (t = x) !== c && (t = z()), t;
      }()) !== c ? (n = f(n, r, e), t = n) : (K = t, t = c)), t;
    }()) === c && (n = function () {
      var n, r, e, o;
      return n = K, (r = function () {
        var n;
        return t.substr(K, 7).toLowerCase() === w ? (n = t.substr(K, 7), K += 7) : (n = c, tt(A)), n === c && (t.substr(K, 5).toLowerCase() === y ? (n = t.substr(K, 5), K += 5) : (n = c, tt(j))), n !== c && (n = F()), n;
      }()) !== c && (e = ot()) !== c && (o = it()) !== c ? (r = C(r, e, o), n = r) : (K = n, n = c), n;
    }()) === c && (n = function () {
      var t, n, r;
      return t = K, (n = ot()) !== c && (r = it()) !== c ? (n = S(n, r), t = n) : (K = t, t = c), t;
    }()) === c && (n = function () {
      var n, r, e;
      return n = K, (r = function () {
        var n;
        return (n = function () {
          var n, r, e;
          return n = K, 46 === t.charCodeAt(K) ? (r = Z, K++) : (r = c, tt(I)), r !== c && (e = at()) !== c ? n = r = [r, e] : (K = n, n = c), n;
        }()) === c && (n = x), n;
      }()) !== c && (e = it()) !== c ? (r = B(e), n = r) : (K = n, n = c), n;
    }()), n;
  }

  function rt() {
    var n, r;
    return t.substr(K, 7).toLowerCase() === p ? (r = t.substr(K, 7), K += 7) : (r = c, tt(h)), r !== c && (r = g()), (n = r) === c && (n = function () {
      var n;
      return t.substr(K, 8).toLowerCase() === v ? (n = t.substr(K, 8), K += 8) : (n = c, tt(d)), n !== c && (n = b()), n;
    }()), n;
  }

  function et() {
    var n, r, e;
    if (n = K, r = [], (e = lt()) !== c) for (; e !== c;) {
      r.push(e), e = lt();
    } else r = c;
    return (n = r !== c ? t.substring(n, K) : r) === c && (n = K, (r = x) !== c && (r = m()), n = r), n;
  }

  function ot() {
    var n;
    return (n = function () {
      var n, r, e, o;
      return n = K, (r = at()) === c && (r = null), r !== c ? (E.test(t.charAt(K)) ? (e = t.charAt(K), K++) : (e = c, tt(L)), e !== c ? (58 === t.charCodeAt(K) ? (o = R, K++) : (o = c, tt($)), o !== c && at() !== c ? (r = M(e), n = r) : (K = n, n = c)) : (K = n, n = c)) : (K = n, n = c), n;
    }()) === c && (n = ut()), n;
  }

  function ut() {
    var t;
    return (t = at()) !== c && (t = k()), t;
  }

  function it() {
    var t;
    return (t = function t() {
      var n, r, e;
      return n = K, (r = ct()) !== c && at() !== c && (e = t()) !== c ? (r = P(r, e), n = r) : (K = n, n = c), n === c && (n = K, (r = ct()) !== c && (r = T(r)), n = r), n;
    }()) !== c && (t = O(t)), t;
  }

  function ct() {
    var n, r, e;
    if (n = K, r = [], (e = lt()) !== c) for (; e !== c;) {
      r.push(e), e = lt();
    } else r = c;
    return (n = r !== c ? t.substring(n, K) : r) === c && (n = x), n;
  }

  function at() {
    var n;
    return 47 === t.charCodeAt(K) ? (n = U, K++) : (n = c, tt(q)), n === c && (92 === t.charCodeAt(K) ? (n = D, K++) : (n = c, tt(G))), n;
  }

  function lt() {
    var n;
    return H.test(t.charAt(K)) ? (n = t.charAt(K), K++) : (n = c, tt(J)), n;
  }

  if ((e = l()) !== c && K === t.length) return e;
  throw e !== c && K < t.length && tt({
    type: "end"
  }), o = V, u = Q < t.length ? t.charAt(Q) : null, i = Q < t.length ? _(Q, Q + 1) : _(Q, Q), new n(n.buildMessage(o, u), o, u, i);
};

function e(t) {
  if ("string" != typeof t) throw new Error("@stoplight/path: Cannot parse ".concat(t, " because it is not a string"));
  return r(t, {});
}

function o(n) {
  return t(u(e(n)));
}

function u(t) {
  var n = t.path;
  n = n.filter(function (t) {
    return "" !== t && "." !== t;
  });
  var r = [];

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      ".." === _e && r.length && ".." !== r[r.length - 1] ? r.pop() : ".." === _e && t.absolute || r.push(_e);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t.path = r, t;
}

function i(t) {
  var n = t.lastIndexOf(".");
  ".." === t && (n = -1), "." === t && (n = -1);
  var r = t,
      e = "";
  return n > 0 && (r = t.slice(0, n), e = t.slice(n)), {
    name: r,
    ext: e
  };
}

var c = function c(t, n) {
  var r = u(e(t)).path.pop();
  if (!r) return "";

  var _i = i(r),
      o = _i.name,
      c = _i.ext;

  return !0 === n || n === c ? o : "".concat(o).concat(c);
},
    a = function a(n) {
  var r = u(e(n));
  return r.path.pop(), t(u(r));
},
    l = function l(t) {
  var n = u(e(t)).path.pop();
  if (!n) return "";

  var _i2 = i(n),
      r = _i2.ext;

  return r;
};

function s(t) {
  return e(t).absolute;
}

function f(t) {
  var n = e(t);
  return "http" === n.protocol || "https" === n.protocol;
}

var p = function p() {
  for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
    n[_key] = arguments[_key];
  }

  if (0 === n.length) return ".";
  var r = n.map(e),
      o = Object.assign({}, r[0]);

  for (var _t = 1; _t < r.length; _t++) {
    var _e2 = r[_t];
    if (_e2.absolute) throw new Error('Cannot join an absolute path "' + n[_t] + '" in the middle of other paths.');

    var _iterator2 = _createForOfIteratorHelper(_e2.path),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _t2 = _step2.value;
        o.path.push(_t2);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return t(u(o));
};

function h(n, r) {
  var _o$path;

  var o = u(e(r));
  if (!o.absolute) return t(o);
  var i = u(e(n));
  if (o.origin !== i.origin) return t(o);
  if (!i.absolute) return t(o);
  if (i.drive !== o.drive) return t(o);
  var c = Math.min(i.path.length, o.path.length);

  for (var _t3 = 0; _t3 < c && i.path[0] === o.path[0]; _t3++) {
    i.path.shift(), o.path.shift();
  }

  return (_o$path = o.path).unshift.apply(_o$path, _toConsumableArray(i.path.fill(".."))), t({
    origin: null,
    drive: null,
    absolute: !1,
    protocol: null,
    path: o.path
  });
}

function g() {
  var _ref;

  if (0 === arguments.length) return ".";
  var r = u(e((_ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref])));
  return r.absolute ? t(r) : p.apply(void 0, arguments);
}

var v = "/",
    d = function d(t) {
  return null !== e(t).drive;
},
    b = function b(t) {
  return e(t).path.filter(Boolean).join("/");
};

function x(t) {
  var _t$split = t.split("/"),
      _t$split2 = _toArray(_t$split),
      n = _t$split2[0],
      r = _t$split2[1],
      e = _t$split2[2],
      o = _t$split2.slice(3),
      u = o.length ? "/".concat(o.join("/")) : void 0;

  var c, a;
  return u && (c = o.find(function (t) {
    return t.includes(".");
  })) && (a = i(c).ext), {
    shortcode: n,
    orgSlug: r,
    projectSlug: e,
    uri: u,
    file: c,
    ext: a
  };
}

function m(_ref2) {
  var t = _ref2.shortcode,
      n = _ref2.orgSlug,
      r = _ref2.projectSlug,
      _ref2$uri = _ref2.uri,
      e = _ref2$uri === void 0 ? "" : _ref2$uri;
  return [t, n, r, e.replace(/^\//, "")].filter(Boolean).join("/");
}

export { c as basename, x as deserializeSrn, a as dirname, l as extname, t as format, s as isAbsolute, f as isURL, p as join, o as normalize, e as parse, h as relative, g as resolve, v as sep, m as serializeSrn, d as startsWithWindowsDrive, b as stripRoot, o as toFSPath };